import type { RenderedBlock, RenderedDocument } from "./blocks";
import { GeoJsonView } from "./geojson.view";

export class BlockTree {
  #document: RenderedDocument;
  #blockIndex: Map<string, RenderedBlock>;

  constructor(document: RenderedDocument) {
    this.#document = document;
    this.#blockIndex = new Map(
      document.blocks?.map((block) => [block.id, block]) ?? [],
    );
  }

  #getBlock(id: string): RenderedBlock {
    const block = this.#blockIndex.get(id);
    // We return a pending block as our index might be just out of date
    // Given that document.content or block.content is not guaranteed to be up-to-date
    // with the "blocks" table.
    if (!block) {
      return {
        id: id,
        type: "pending",
        attributes: {},
        documentId: "",
        content: [],
      };
    }
    return block;
  }

  #getContentBlocks(contentIds: string[]): RenderedBlock[] {
    return contentIds
      .map((id) => this.#getBlock(id))
      .filter((block) => !block.deleted);
  }

  get document(): RenderedDocument {
    return this.#document;
  }

  getDocumentRoot(): RenderedBlock[] {
    return this.#getContentBlocks(this.#document.content);
  }

  getBlockTree(id: string): RenderedBlock[] {
    return this.#getContentBlocks(this.#getBlock(id).content);
  }

  toGeoJSON(): GeoJSON.FeatureCollection {
    return GeoJsonView(this);
  }
}
